import { render, staticRenderFns } from "./invoiceTask.vue?vue&type=template&id=e1580b90&scoped=true"
import script from "./invoiceTask.vue?vue&type=script&lang=js"
export * from "./invoiceTask.vue?vue&type=script&lang=js"
import style0 from "./invoiceTask.vue?vue&type=style&index=0&id=e1580b90&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e1580b90",
  null
  
)

export default component.exports